import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getBackNavigation } from '../utils/backNavigation';

// Explicit navigation from a form, a sheet action or a tab must remove the
// temporary guard first, otherwise Back can revisit an abandoned form.
export default function useSafeNavigate() {
    const navigate = useNavigate();
    return useCallback((...args) => getBackNavigation().leave(() => navigate(...args)), [navigate]);
}
